import * as React from 'react';
export const IcPets = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.08 8a2.94 2.94 0 002-.89 2.49 2.49 0 00.3-3.52 2.49 2.49 0 00-3.52.3 2.49 2.49 0 00-.3 3.52A2.07 2.07 0 007.08 8zm6.19.77a3.28 3.28 0 002.27-1 2.76 2.76 0 00.35-3.89 2.76 2.76 0 00-3.89.35 2.76 2.76 0 00-.35 3.89 2.23 2.23 0 001.62.65zM17.74 13A3.27 3.27 0 0020 12c.53-.5.881-1.16 1-1.88a2.32 2.32 0 00-.62-2 2.76 2.76 0 00-3.89.35 3.39 3.39 0 00-1 1.88 2.34 2.34 0 00.62 2 2.27 2.27 0 001.63.65zm2.67 1.58a2.489 2.489 0 00-3.52.3 2.49 2.49 0 00-.3 3.52 2.071 2.071 0 001.49.59 2.94 2.94 0 002-.89 2.49 2.49 0 00.33-3.51v-.01zM9.14 9.05l-3.53.64A3.18 3.18 0 003 12.82V13a3 3 0 003 3 2 2 0 012 2 3 3 0 003 3h.18a3.18 3.18 0 003.13-2.61l.69-3.53a5 5 0 00-5.86-5.81z'
      fill='currentColor'
    />
  </svg>
);
